
export default {
  // eslint-disable-next-line vue/require-default-prop
  props: { data: Object },

  data() {
    return {
      imagePreview: null,
      tenantOptions: ['Tenant A', 'Tenant B'],
      storeOptions: ['Location A', 'Location B']
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Optional: Validate file type & size
      if (!file.type.startsWith('image/')) {
        alert('Please select a valid image file.');
        return;
      }

      const reader = new FileReader();
      reader.onload = e => {
        this.imagePreview = e.target.result;
        this.$emit('update:image', file); // Emit the file to parent if needed
      };
      reader.readAsDataURL(file);
    },
    copyToClipboard(text) {
      if (!text) return;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$q.notify({
            type: 'positive',
            message: 'Copied to clipboard!'
          });
        })
        .catch(() => {
          this.$q.notify({
            type: 'negative',
            message: 'Failed to copy'
          });
        });
    }
  }
};
